import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'

const DevKeyForm = ({organization, setOrganization, toggle}) => {
  const [currentState, dispatch] = useStateValue()
  const devKey = organization.devKey

  const [appId, updateAppId] = useState(devKey ? devKey.appId : '')
  const [appKey, updateAppKey] = useState(devKey ? devKey.appKey : '')

  const [showRequiredAppId, setShowRequiredAppId] = useState(false)
  const [showRequiredAppKey, setShowRequiredAppKey] = useState(false)

  const handleAppIdChange = e => {
    updateAppId(e.target.value)
  }

  const handleAppKeyChange = e => {
    updateAppKey(e.target.value)
  }

  const addDevKey = async () => {
    if (!appId || !appKey) {
      setShowRequiredAppId(appId === '')
      setShowRequiredAppKey(appKey === '')
    }

    try {
      const resp = await client.post(endpoints.addDevKey({ orgId: organization.id }), {
        ...devKey,
        appId: appId,
        appKey: appKey,
      })
      toast.success("Successfully saved the Dev Key.")
      toggle(false)
      setOrganization(resp.data.organization)
      // Updates the label in OrganizationAttributes.js
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
    } catch (err) {
      let errMsg = "There was an error trying to save the Dev Key."
      if (err.response.data.error) {
        errMsg = err.response.data.error
      }
      toast.error(errMsg)
    }
  }

  const deleteDevKey = async () => {

    try {
      const resp = await client.delete(endpoints.deleteDevKey({ orgId: organization.id }))
      toast.success("Successfully deleted the Dev Key.")
      toggle(false)
      setOrganization(resp.data.organization)
      // Updates the label in OrganizationAttributes.js
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
    } catch (err) {
      let errMsg = "There was an error trying to delete the Dev Key."
      if (err.response.data.error) {
        errMsg = err.response.data.error
      }
      toast.error(errMsg)
    }

  }

  const requiredAppId = showRequiredAppId && <span> Required</span>
  const requiredAppKey = showRequiredAppKey && <span> Required</span>

  const addBtn = devKey ? (
    <div className="d-flex justify-content-between">
      <div
        className="btn btn-success btn-myed btn-warning-myed"
        onClick={() => addDevKey()}
      >
        <div className="fa-regular fa-cog fa-fw mr-2" /> Update
      </div>
      <div
        className="btn btn-success btn-myed btn-danger-myed"
        onClick={() => deleteDevKey()}
      >
        <div className="fa-regular fa-times fa-fw mr-2" /> Remove
      </div>
    </div>
  ) : (
      <div
        className="btn btn-success btn-myed btn-success-myed"
        onClick={() => addDevKey()}
      >
        <div className="fa-regular fa-plus fa-fw mr-2" /> Add
      </div>
  )


  return (
    <Fragment>
      <Form.Group controlId="appId">
        <Form.Label>App ID<span className='text-orange'>{requiredAppId}*</span></Form.Label>
        <Form.Control type="text" onChange={handleAppIdChange} value={appId} />
      </Form.Group>
      <Form.Group controlId="appKey">
        <Form.Label>App Key<span className='text-orange'>{requiredAppKey}*</span></Form.Label>
        <Form.Control type="text" onChange={handleAppKeyChange} value={appKey} />
      </Form.Group>
      {addBtn}
    </Fragment>
  )
}

DevKeyForm.propTypes = {
  organization: PropTypes.object.isRequired,
  setOrganization: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default DevKeyForm
